import { MoonIcon, SunIcon } from '@heroicons/react/24/solid';
import { useTheme } from '../../lib/theme';

export function ThemeToggle(): JSX.Element {
  const { mode, toggle } = useTheme();

  return (
    <button
      type="button"
      onClick={toggle}
      className="btn-glass btn-secondary focus-ring inline-flex items-center gap-2 text-xs font-medium sm:text-sm"
      aria-label="Toggle theme"
    >
      {mode === 'dark' ? (
        <SunIcon className="h-4 w-4 text-foreground" />
      ) : (
        <MoonIcon className="h-4 w-4 text-foreground" />
      )}
      <span className="hidden sm:inline">{mode === 'dark' ? 'Light mode' : 'Dark mode'}</span>
    </button>
  );
}
